import { render, staticRenderFns } from "./Agreements.vue?vue&type=template&id=c7c3c5d8&scoped=true"
import script from "./Agreements.vue?vue&type=script&lang=js"
export * from "./Agreements.vue?vue&type=script&lang=js"
import style0 from "./Agreements.vue?vue&type=style&index=0&id=c7c3c5d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c3c5d8",
  null
  
)

export default component.exports